<div class="vtc" [class.vtc--compact]="compact" [style.--plot-h.px]="heightPx">
  <div class="vtc__empty" *ngIf="!hasData">{{ 'audiences.trend.noData' | translate }}</div>

  <ng-container *ngIf="hasData">
    <div class="vtc__legend" *ngIf="!compact">
      <span class="vtc__legend-item" *ngFor="let s of presentSeries">
        <span class="vtc__swatch" [style.background]="s.color"></span>
        {{ 'audiences.trend.series.' + s.key | translate }}
      </span>
    </div>

    <div class="vtc__row">
      <div class="vtc__yaxis" *ngIf="!compact" aria-hidden="true">
        <span class="vtc__ytick" *ngFor="let t of yTicks" [style.top.%]="t.pct">
          {{ (t.value < 0 ? '−' : '') + formatNumber(t.value < 0 ? -t.value : t.value) }}
        </span>
      </div>

      <div class="vtc__bars" (mouseleave)="onBarLeave()">
        <div class="vtc__zero" [style.top.%]="zeroPct"></div>

        <div class="vtc__col"
             *ngFor="let bar of bars; trackBy: trackByDate"
             [class.is-hovered]="hoveredDate === bar.date"
             (mouseenter)="onBarEnter(bar)">
          <span class="vtc__seg" *ngFor="let seg of bar.segments"
                [class.vtc__seg--removed]="seg.key === 'removed'"
                [style.top.%]="seg.top" [style.height.%]="seg.height" [style.background]="seg.color"></span>

          <div class="vtc__tooltip" *ngIf="hoveredDate === bar.date">
            <div class="vtc__tooltip-date">{{ bar.date }}</div>
            <div class="vtc__tooltip-row" *ngIf="bar.existing > 0">
              <span class="dot" [style.background]="seriesColor('existing')"></span>
              <span class="k">{{ 'audiences.trend.series.existing' | translate }}</span>
              <span class="v">{{ formatNumber(bar.existing) }}</span>
            </div>
            <div class="vtc__tooltip-row" *ngIf="bar.new > 0">
              <span class="dot" [style.background]="seriesColor('new')"></span>
              <span class="k">{{ 'audiences.trend.series.new' | translate }}</span>
              <span class="v">{{ formatNumber(bar.new) }}</span>
            </div>
            <div class="vtc__tooltip-row" *ngIf="bar.removed > 0">
              <span class="dot" [style.background]="seriesColor('removed')"></span>
              <span class="k">{{ 'audiences.trend.series.removed' | translate }}</span>
              <span class="v">−{{ formatNumber(bar.removed) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="vtc__labels" *ngIf="!compact">
      <span class="vtc__label" *ngFor="let bar of bars; trackBy: trackByDate">{{ bar.label }}</span>
    </div>
  </ng-container>
</div>
